import { createFileRoute } from '@tanstack/react-router'
import SettingsDesktop from '@/features/settings/desktop'

export const Route = createFileRoute('/_authenticated/settings/desktop')({
  component: SettingsDesktop,
})
